import { Download1Stroke, Pencil1Stroke, PlusStroke, Search1Stroke, Trash3Stroke } from '@lineiconshq/free-icons';
import { TEMPLATE_BASE64 as excelTemplate_mua_hang_hoa_don_dieu_chinh_tra_lai_phieu_xuat_tra_lai_nha_cung_cap_PXTLNCC } from '@/lib/templates-base64/PXTLNCC';
import { ActionBarV2, ActionButtonV2, AritoIcon, MenuButtonV2 } from '@/components/custom/erp';
import { usePhieuXuatTraLaiNhaCungCapContext } from '../context';
import { downloadBase64Excel } from '@/lib/template-downloader';

interface ActionBarProps {
  className?: string;
  onRefreshClick?: () => Promise<void>;
}

export default function ActionBar({ className, onRefreshClick }: ActionBarProps) {
  const { export: exportContext, forms, crud, search, import: importContext } = usePhieuXuatTraLaiNhaCungCapContext();
  const { exportToExcel, canExport, isExporting } = exportContext;
  const { handleAddClick, handleEditClick, handleDeleteClick, handleCopyClick, selectedObj } = forms;
  const { refreshData } = crud;
  const { handleSearch } = search;
  const { openImportDialog } = importContext;

  const handleRefresh = async () => {
    if (onRefreshClick) {
      await onRefreshClick();
    } else {
      await refreshData();
    }
  };

  const handleDownloadExcelTemplate = () => {
    downloadBase64Excel(
      excelTemplate_mua_hang_hoa_don_dieu_chinh_tra_lai_phieu_xuat_tra_lai_nha_cung_cap_PXTLNCC,
      'Phiếu xuất trả lại nhà cung cấp.xlsx'
    );
  };

  const isEditDisabled = !selectedObj;
  return (
    <ActionBarV2 className={className} title='Phiếu xuất trả lại nhà cung cấp'>
      <ActionButtonV2 icon={PlusStroke} title='Thêm' onClick={handleAddClick} variant='primary' />
      <ActionButtonV2 icon={Pencil1Stroke} title='Sửa' onClick={handleEditClick} disabled={isEditDisabled} />
      <ActionButtonV2 icon={Trash3Stroke} title='Xoá' onClick={handleDeleteClick} disabled={isEditDisabled} />
      <ActionButtonV2 icon={Download1Stroke} title='Sao chép' onClick={handleCopyClick} disabled={isEditDisabled} />
      <ActionButtonV2 icon={Search1Stroke} title='Tìm kiếm' onClick={handleSearch} />
      <MenuButtonV2
        title='Khác'
        items={[
          {
            title: 'Refresh',
            icon: <AritoIcon icon={15} />,
            onClick: handleRefresh,
            group: 0
          },
          {
            title: 'Cố định cột',
            icon: <AritoIcon icon={18} />,
            onClick: () => {},
            group: 0
          },
          {
            title: 'Kết xuất dữ liệu',
            icon: <AritoIcon icon={555} />,
            onClick: exportToExcel,
            disabled: !canExport || isExporting,
            loading: isExporting,
            loadingTitle: 'Đang kết xuất...',
            group: 1
          },
          {
            title: 'Tải mẫu Excel',
            icon: <AritoIcon icon={28} />,
            onClick: handleDownloadExcelTemplate,
            group: 1
          },
          {
            title: 'Lấy dữ liệu từ Excel',
            icon: <AritoIcon icon={29} />,
            onClick: openImportDialog,
            group: 1
          }
        ]}
      />
    </ActionBarV2>
  );
}
